<template>
    <v-dialog v-model="value" max-width="500px" persistent>
        <v-card class="my-auto rounded-xl"
                :class="isMobile ? ['pt-4'] : ['pt-8']"
                max-width="500px"
                flat>
            <v-row justify="end" class="mt-2 mr-2">
                <v-hover v-slot="{hover}">
                    <v-btn :color="hover ? 'linkHover' : 'primary'"
                           dark
                           text
                           plain
                           class="text-none text-large"
                           @click="closeDialog()">
                        <v-icon height="24px" width="24px">mdi-close</v-icon>
                    </v-btn>
                </v-hover>
            </v-row>
            <v-img class="mx-auto px-5 login-logo"
                   :src="`../../assets/Branding/${this.$experience.key}/Images/${getLogo}`"
                   max-width="270px"
                   contain>
            </v-img>
            <v-card-text>
                <v-stepper v-model="step" flat>
                    <v-stepper-items>
                        <v-stepper-content class="pa-0" step="1">
                            <v-container>
                                <v-subheader class="card-title d-block py-0 text-center">{{$t('register.subTitleStep3')}}</v-subheader>
                                <v-row class="pa-0 ma-0" justify="center">
                                    <v-alert v-if="step1ErrorMsg != null"
                                             class="mx-2 pa-3 d-inline-block"
                                             dense
                                             dark
                                             type="error">{{$t(this.step1ErrorMsg)}}</v-alert>
                                </v-row>
                                <v-form ref="step1Form">

                                    <v-list flat class="mb-2" v-model="registerViewModel.reportsLst">
                                        <v-list-item v-for="(report) in registerViewModel.reportsLst"
                                                     :key="report.Id"
                                                     class="px-0">
                                            <template>
                                                <div class="list-item my-1">
                                                    <v-row align="center" class="mx-2">
                                                        <v-list-item-action>
                                                            <v-checkbox v-model="report.Checked" @change="updateStep1Valid()"></v-checkbox>
                                                        </v-list-item-action>
                                                        <v-list-item-content>
                                                            <v-list-item-title class="text-normal text-left">{{reportTitle(report)}}</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-row>
                                                </div>
                                            </template>
                                        </v-list-item>
                                    </v-list>
                                </v-form>

                                <v-row justify="end" class="my-3 mr-0">
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none text-normal min-height-1"
                                               :disabled="!isStep1ButtonActive"
                                               :dark="isStep1ButtonActive"
                                               depressed
                                               :color="hover ? 'buttonHover' : 'primary'"
                                               @click="onNextStep1"
                                               :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                            {{$t('register.next')}}
                                            &nbsp;
                                            <v-progress-circular v-if="formProcess" indeterminate
                                                                 color="primary">
                                            </v-progress-circular>
                                        </v-btn>
                                    </v-hover>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                        <v-stepper-content class="pa-0" step="2">
                            <v-container class="px-0">
                                <v-subheader class="card-title d-block py-0 text-center">{{$t('register.subTitleStep4')}}</v-subheader>
                                <v-row class="pa-0 ma-0" justify="center">
                                    <v-alert v-if="step2ErrorMsg != null"
                                             class="mx-2 pa-3 d-inline-block"
                                             dense
                                             dark
                                             type="error">
                                        {{ $t(step2ErrorMsg) }}
                                        <span v-html="step2ReportsList" />
                                    </v-alert>
                                </v-row>
                                <v-form ref="step2Form"
                                        v-model="step2Valid">

                                    <v-list flat
                                            class="ma-0 pa-0">
                                        <template v-for="(report) in registerViewModel.choosenReports">
                                            <v-list-item :key="report.Id"
                                                         class="ma-0 pa-0">
                                                <v-card outlined width="100%" class="mx-3 mt-1 rounded-lg">
                                                    <v-list-item-content class="ma-0 pa-0">
                                                        <v-subheader class="text-normal py-0 font-weight-bold">{{reportTitle(report)}}</v-subheader>
                                                        <v-list flat
                                                                class="mb-1">
                                                            <v-list-item v-for="(attribute) in report.Attributes"
                                                                         :key="attribute.AttributeId"
                                                                         class="mx-4 pa-0 d-block">
                                                                <v-row class="ma-0 pt-3" align="center">
                                                                    <v-text-field v-model="attribute.Value"
                                                                                  :label="attributeName(attribute)"
                                                                                  class="text-normal min-height-1  mb-2"
                                                                                  outlined
                                                                                  required
                                                                                  hide-details
                                                                                  maxlength="255"
                                                                                  :rules="requiredRules"
                                                                                  @input="clearStep2ErrorMsg"></v-text-field>
                                                                </v-row>
                                                                <v-row v-if="attribute.DescriptionFr" class="ma-0 pa-0" align="center">
                                                                    <span class="text-small mx-2">{{$i18n.locale == 'fr' ? attribute.DescriptionFr : attribute.DescriptionEn}}</span>
                                                                </v-row>

                                                            </v-list-item>
                                                        </v-list>
                                                    </v-list-item-content>
                                                </v-card>
                                            </v-list-item>
                                        </template>
                                    </v-list>
                                </v-form>

                                <v-row justify="space-between" class="ma-3">
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none text-normal min-height-1"
                                               dark
                                               depressed
                                               :color="hover ? 'buttonHover' : 'primary'"
                                               @click="step = 1"
                                               :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                            {{$t('register.previous')}}
                                        </v-btn>
                                    </v-hover>
                                    <v-hover v-slot="{hover}">
                                        <v-btn class="text-none text-normal min-height-1"
                                               :disabled="!isStep2ButtonActive"
                                               :dark="isStep2ButtonActive"
                                               depressed
                                               :color="hover ? 'buttonHover' : 'primary'"
                                               @click="onNextStep2(false)"
                                               :min-width="$vuetify.breakpoint.smAndDown ? '150px' : '40%'">
                                            {{$t('register.subscribe')}}
                                            &nbsp;
                                            <v-progress-circular v-if="formProcess" indeterminate
                                                                 color="primary">
                                            </v-progress-circular>
                                        </v-btn>
                                    </v-hover>
                                </v-row>
                            </v-container>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-card-text>
        </v-card>
        <v-dialog v-model="successSnackbar" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="#74DF13"
                            class="my-5">mdi-check-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1"><span v-html="successMessage"></span></v-card-subtitle>
            </v-card>
        </v-dialog>
        <v-dialog v-model="errorSnackbar" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="red"
                            class="my-5">mdi-close-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ $t('user-management.reportAccessErrorText') }}</v-card-subtitle>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ (errorMessage != null? errorMessage: '') }}</v-card-subtitle>
                <v-card-actions>
                    <v-row justify="center">
                        <v-btn class="text-normal" depressed color="primary" width="33%" x-large @click="errorSnackbar = false">OK</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="userDuplicateFlow" max-width="615px">
            <v-card class="pa-8 rounded-xl" flat>
                <v-row align="center" justify="center">
                    <v-icon size="96px"
                            color="warning"
                            class="my-5">mdi-alert-circle-outline</v-icon>
                </v-row>
                <v-card-subtitle class="text-center card-subtitle font-weight-medium mt-1">{{ $t('register.duplicateUserDataError') }}</v-card-subtitle>
                <v-card-subtitle class="text-center card-subtitle2 font-weight-medium mt-1">{{ $t('register.continueWithDupes') }}</v-card-subtitle>
                <v-card-actions>
                    <v-row justify="space-between">
                        <v-btn class="text-normal" depressed color="primary" x-large @click="userDuplicateFlow = false">{{$t('cancel')}}</v-btn>
                        <v-btn class="text-normal" depressed color="warning" x-large @click="onNextStep2(true); ">{{$t('continue')}}</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
    import { apiService } from "../services";
    import { mapState, mapActions } from "vuex";

    export default {
        name: "onboarding",
        props: ['value'],
        data() {
            return {
                registerViewModel: {
                    choosenReports: [],
                    reportsLst: [],
                },
                step: 1,
                step1Valid: false,
                step1ErrorMsg: undefined,
                step2Valid: false,
                step2ErrorMsg: undefined,
                step2ErrorReports: undefined,
                requiredRules: [
                    v => !!v || this.$t('register.fieldRequired')
                ],
                logo: "",
                formProcess: false,
                successSnackbar: false,
                successMessage: undefined,
                errorSnackbar: false,
                errorMessage: undefined,
                userDuplicateFlow: false
            }
        },
        computed: {
            ...mapState("account", ["status", "user"]),
            step2ReportsList() {
                if (this.step2ErrorReports == null || this.step2ErrorReports.length == 0) return '';
                var list = '';
                for (var i = 0; i < this.step2ErrorReports.length; i++) {
                    var index = this.registerViewModel.reportsLst.findIndex(x => x.Id == this.step2ErrorReports[i]);
                    if (index >= 0) {
                        list += `<br/>${(this.$i18n.locale == 'fr' ? this.registerViewModel.reportsLst[index].TitleFr : this.registerViewModel.reportsLst[index].TitleEn)}`;
                    }
                }
                return list;
            },
            isStep1ButtonActive() {
                return !this.formProcess && this.step1Valid;
            },
            isStep2ButtonActive() {
                return !this.formProcess && this.step2Valid && !this.step2ErrorMsg;
            },
            isMobile() {
                return this.$vuetify.breakpoint.smAndDown;
            },
            getLogo() {
                return (this.$i18n.locale == 'en' && this.$experience.logoLoginEN != null) ? this.$experience.logoLoginEN : this.$experience.logo;
            }
        },
        created() {
        },
        mounted() {
            
        },
        methods: {
            ...mapActions("account", ["login"]),

            fieldRequired(val) {
                return this.$t('register.fieldRequired', { field: this.$t(val) });
            },
            textLengthRule(fieldName, n) {
                return this.$t('register.textLengthRule', { field: this.$t(fieldName), n: n })
            },
            getReports() {
                this.formProcess = true;
                apiService.getClientReportsList()
                    .then((response) => {
                        this.formProcess = false;
                        if (response.data.success) {
                            if (response.data.reportsLst) {
                                this.registerViewModel.reportsLst = response.data.reportsLst
                                this.registerViewModel.reportsLst.forEach((report) => {
                                    response.data.reportAccess.forEach((access) => {
                                        if (access.IndexDefinitionId === report.Id) {
                                            report.Checked = true;
                                        }
                                    })
                                    report.Checked = !report.Checked;
                                });
                                this.updateStep1Valid();
                            }
                            this.step1ErrorMsg = undefined;
                        } else if (response.data.success == false && response.data.error == 'session-expired') {
                            self.$router.push({ name: 'login' });
                        } 
                    })
                    .catch((error) => {
                        this.formProcess = false;
                        this.step1ErrorMsg = error;
                    })

            },
            clearStep2ErrorMsg() {
                this.step2ErrorMsg = undefined;
            },
            updateStep1Valid() {
                let valid = false;
                for (let i = 0; i < this.registerViewModel.reportsLst.length; i++) {
                    valid = valid || this.registerViewModel.reportsLst[i].Checked;
                }
                this.step1Valid = valid;
            },
            onNextStep1() {
                this.registerViewModel.choosenReports = [];
                this.registerViewModel.choosenReports = this.registerViewModel.reportsLst.filter(rpt => rpt.Checked);
                this.step = 2;
            },
            onNextStep2(ignoreDuplicates) {
                this.step2ErrorMsg = undefined;
                this.userDuplicateFlow = false;
                this.$refs.step2Form.validate();
                if (this.step2Valid) {
                    this.formProcess = true;
                    apiService.processOnBoarding(this.registerViewModel.choosenReports, ignoreDuplicates)
                        .then((response) => {
                            this.formProcess = false;
                            if (response.data.success) {
                                this.step2ErrorMsg = undefined;
                                this.onSubscribe();
                            } else if (response.data.success == false && response.data.error == 'session-expired') {
                                self.$router.push({ name: 'login' });
                            } 

                        })
                        .catch((error) => {
                            this.formProcess = false;
                            if (error.msg === 'register.duplicateUserDataError') {
                                this.userDuplicateFlow = true;
                            } else {
                                this.step2ErrorMsg = error.msg;
                                this.step2ErrorReports = error.reportErrorList;
                            }
                        })
                }
            },
            reportTitle(report) {
                if (this.$i18n.locale == "fr") {
                    return report.TitleFr;
                } else {
                    return report.TitleEn;
                }
            },
            attributeName(attribute) {
                if (this.$i18n.locale == "fr") {
                    return attribute.NameFr;
                } else {
                    return attribute.NameEn;
                }
            },
            resetDialog() {
                this.registerViewModel.choosenReports = [];
                for (let i = 0; i < this.registerViewModel.reportsLst.length; i++) {
                    this.registerViewModel.reportsLst[i].Checked = false;
                    for (let y = 0; y < this.registerViewModel.reportsLst[i].Attributes.length; y++) {
                        this.registerViewModel.reportsLst[i].Attributes[y].Value = '';
                    }
                }
                this.step = 1;
                this.step1Valid = false;
                this.step1ErrorMsg = undefined;
                this.step2Valid = false;
                this.step2ErrorMsg = undefined;
                this.formProcess = false;
                
            },
            closeDialog() {
                this.resetDialog();
                this.$emit('close');
            },
            onSubscribe() {
                this.resetDialog();
                this.$emit('subscribe');
            }
        },
        watch: {
            $route() {
                // clear alert on location change
                this.clearAlert();
            },
            value(val) {
                if (val) {
                    this.getReports();
                }
            }
        }
    }
</script>

<style scoped>
    .login-logo {
        margin-top: 50px !important;
        margin-bottom: 50px !important;
    }

    .mfaSVG {
        position: absolute;
        top: 50%;
        width: 100%;
        height: 50%;
    }

    .mfaSVG-mobile {
        position: absolute;
        top: 48px;
        width: 100%;
        height: 50%;
    }

    .list-item {
        border: 1px solid;
        border-radius: 10px;
        min-height: 67px;
        min-width: 100%;
        display: flex;
        align-items: center;
        border-color: darkgray;
    }

        .list-item:hover {
            border-color: black;
        }
</style>
